import type {
  LessonDto,
  SlideDto,
  OptionDto,
  AnswerDto,
  LessonAnswerDto,
  LessonAnswerReportDto
} from '../../../../api/generated/types.gen';

// Import backend types (re-export with uppercase DTO for backward compatibility)
export type LessonDTO = LessonDto;
export type SlideDTO = SlideDto;
export type OptionDTO = OptionDto;
export type AnswerDTO = AnswerDto;
export type LessonAnswerDTO = LessonAnswerDto;
export type LessonAnswerReportDTO = LessonAnswerReportDto;

// Lesson types enum
export enum LessonType {
  LESSON = 'LESSON',
  HOMEWORK = 'HOMEWORK',
  PRACTICAL_ACTIVITY = 'PRACTICAL_ACTIVITY',
  MONTHLY_CHALLENGE = 'MONTHLY_CHALLENGE',
  DAILY_CHALLENGE = 'DAILY_CHALLENGE', // Disabled but supported
  CLASS_EXERCISE = 'CLASS_EXERCISE',
  /** Provocare pentru SCOALA: o depune profesorul, cu dovezi; o singura depunere punctata per scoala. */
  SCHOOL_CHALLENGE = 'SCHOOL_CHALLENGE',
}

// Role enum matching backend
export enum Role {
  DBEST = 'DBEST',
  ADMIN = 'ADMIN',
  PROFESOR = 'PROFESOR',
  ELEV = 'ELEV',
  LOGISTIC = 'LOGISTIC',
  SYNC = 'SYNC',
}

// Lesson attempt state enum (matches backend state machine)
export enum LessonAttemptState {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

// Lesson type configuration interface
export interface LessonTypeConfig {
  type: LessonType;
  displayName: string;
  pluralName: string;
  icon: React.ComponentType<any>;

  features: {
    allowedSlideTypes: string[];
    requiresApproval: boolean;
    allowsMultipleAttempts: boolean;
    hasDeadline: boolean;
    awardsPoints: boolean;
    maxSlides?: number;
    minSlides?: number;
  };

  permissions: {
    create: Role[];
    edit: Role[];
    complete: Role[];
    view: Role[];
    approve: Role[];
  };

  validation: {
    titleMaxLength: number;
    descriptionMaxLength: number;
    customRules?: ValidationRule[];
  };
}

// Validation rule interface
export interface ValidationRule {
  field: string;
  rule: (value: any, lesson: LessonDTO) => boolean;
  message: string;
}

// Extended lesson interface for frontend use
export interface Lesson extends LessonDTO {
  // Frontend-specific properties
  isDirty?: boolean;
  isValid?: boolean;
  errors?: Record<string, string>;
}

// Extended slide interface for frontend use
export interface Slide extends SlideDTO {
  // Frontend-specific properties
  isValid?: boolean;
  errors?: Record<string, string>;
}

// Extended answer interface for frontend use
export interface Answer extends AnswerDTO {
  // Frontend-specific properties
  isSubmitting?: boolean;
  isValid?: boolean;
  errors?: Record<string, string>;
}